import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const prevVassDetailState = atom({
  key: "prevVassDetailState",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
